import { Row, Col, Card, Collapse } from 'antd';
import { convertCentsIntoDollar } from '../../../helpers/genericHelper';
import CustomText from '../../CustomText';
import { PersistedCollapse } from '../../PersistedSections';

const { Panel } = Collapse;

function MonthlySpendPowerComponent({ accountId, data = {}, boostsPending = [] }) {
  return (
    <Card
      bordered={false}
      hoverable={true}
      className="criclebox tablespace mb-16"
    >
      <Row
        className="save-build-box-container"
        gutter={[30, 30]}
        justify="space-between"
      >
        <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
          <h4>Saving Builder Balance</h4>
          <CustomText
            dataSet={data}
            property1={'savingsBuilderBalanceCents'}
            formatter={convertCentsIntoDollar}
          />
        </Col>

        <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
          <h4>Cash Wallet Balance</h4>
          <CustomText
            dataSet={data}
            property1={'cashWalletBalanceCents'}
            formatter={convertCentsIntoDollar}
          />
        </Col>

        <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
          <h4>Boost Complete</h4>
          <CustomText
            dataSet={data}
            property1={'boostsCompletedCents'}
            formatter={convertCentsIntoDollar}
          />
        </Col>

        <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
          <h4>Total Spend Power</h4>
          <CustomText
            dataSet={data}
            property1={'totalSpendPowerCents'}
            formatter={convertCentsIntoDollar}
          />
        </Col>


        <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
          <h4>Gifted Spend Power</h4>
          <CustomText
            dataSet={data}
            property1={'giftedSpendPowerInCents'}
            formatter={convertCentsIntoDollar}
          />
        </Col>

      </Row>
      <Row style={{ marginLeft: 20, marginBottom: 20 }}>
        <Col xs={23} xl={23} sm={23} md={23}>
          <PersistedCollapse name={`spend-power-sections:${accountId}`} defaultActiveKey={[1]}>
            <Panel header="Boosts Completed" key="1">
              {(data && data.boostsCompleted && data.boostsCompleted.length > 0) ?
                data.boostsCompleted.map((_boost) => {
                  return (<Card
                    bordered={false}
                    hoverable={true}
                    className="criclebox tablespace mb-16"
                  >
                    <Row
                      className="save-build-box-container"
                      gutter={[30, 30]}
                      justify="space-between"
                    >
                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>Title</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'title'}
                        />
                      </Col>

                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>Description</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'description'}
                        />
                      </Col>

                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>Amount</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'amountInCents'}
                          formatter={convertCentsIntoDollar}
                        />
                      </Col>

                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>Action</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'action'}
                        />
                      </Col>

                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>Status</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'status'}
                        />
                      </Col>

                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>actionDescription</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'actionDescription'}
                        />
                      </Col>
                    </Row>
                  </Card>
                  )
                }) : <Row className="no-data-card">No Boost Completed Found</Row>}
            </Panel>


            <Panel header="Boosts Pending" key="2">
              {(boostsPending && boostsPending.length > 0) ?
                boostsPending.map((_boost) => {
                  return (<Card
                    bordered={false}
                    hoverable={true}
                    className="criclebox tablespace mb-16"
                  >
                    <Row
                      className="save-build-box-container"
                      gutter={[30, 30]}
                      justify="space-between"
                    >
                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>Title</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'title'}
                        />
                      </Col>

                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>Description</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'description'}
                        />
                      </Col>

                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>Amount</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'amountInCents'}
                          formatter={convertCentsIntoDollar}
                        />
                      </Col>

                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>Action</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'action'}
                        />
                      </Col>

                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>Status</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'status'}
                        />
                      </Col>

                      <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                        <h4>actionDescription</h4>
                        <CustomText
                          dataSet={_boost}
                          property1={'actionDescription'}
                        />
                      </Col>
                    </Row>
                  </Card>
                  )
                }) : <Row className="no-data-card">No Boost Pending Found</Row>}
            </Panel>

          </PersistedCollapse>
        </Col>
      </Row>
    </Card>
  );
}

export default MonthlySpendPowerComponent;
